export default __webpack_public_path__ + "static/media/oneid-small-uk-license.4cba44cb.jpg";